import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidationRule } from 'devextreme/common';

@Component({
    selector: 'app-form-validation',
    imports: [CommonModule],
    template: '',
    styles: []
})
export class FormValidationComponent {
  isRequired = input(false);

  validationRules = computed(() => {
    const rules: ValidationRule[] = [];
    if (this.isRequired()) rules.push({ type: 'required' });
    return rules;
  });
}
